<template>
  <div id="app">
    <!-- App.vue -->

    <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
      <v-navigation-drawer d-block d-md-none v-model="drawer" fixed>
        <v-list nav dense sticky class="mt-10 pt-8">
          <v-list-item-group v-model="group">
            <v-list-item to="/" class="sticky-list-item">
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item>

            <v-list-item href="https://docs.moasure.com" target="_blank">
              <v-list-item-title>User Guide</v-list-item-title>
            </v-list-item>

            <!-- <v-list-item>
              <v-list-item-title>Contact</v-list-item-title>
            </v-list-item> -->
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <div>
        <v-app-bar
          v-if="!$route.meta.hideNav"
          app
          color="primary app-bar"
          class="mx-auto"
          dark
          prominent
          height="auto"
        >
          <!-- -->
          <v-app-bar-nav-icon
            v-if="!$route.meta.hideNav"
            class="d-block d-md-none"
            @click.stop="drawer = !drawer"
          ></v-app-bar-nav-icon>
          <div :class="containerClass">
            <v-app-bar-title class="desktop-links">
              <v-img
                class="header-logo"
                @click="navigateHome()"
                alt=" John"
                width="100px"
                src="https://res.cloudinary.com/do7dtenhu/image/upload/v1712077469/moasure_logo_dark_amhfif.png"
              ></v-img>
            </v-app-bar-title>
            <v-spacer></v-spacer>

            <div class="desktop-links">
              <v-btn
                to="/"
                :ripple="false"
                :color="getActiveColor('home')"
                :class="getActiveTextColor('home')"
              >
                <v-icon left>mdi-home</v-icon
                ><span clas="text--primary">Home</span>
              </v-btn>

              <v-btn
                @click="navigateToUserGuide()"
                targe="blank"
                :ripple="false"
                :color="getActiveColor('user_guide')"
                active-class="custom-active"
                class="elevation-0 mt-2 mr-2"
              >
                <v-icon left>mdi-school</v-icon> User Guide
              </v-btn>
              <v-btn
                @click="navigateToContactPage()"
                :ripple="false"
                color="primary"
                active-class="custom-active"
                class="mt-2 mr-2"
              >
                <v-icon left>mdi-lifebuoy</v-icon> Help
              </v-btn>
              <v-app-bar-nav-icon
                class="d-block d-md-none"
                @click.stop="drawer = !drawer"
              ></v-app-bar-nav-icon>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon v-if="!isMobile">
              <v-icon @click="dialog = true">mdi-magnify</v-icon>
            </v-btn>
          </div>
          <v-spacer v-if="isMobile"></v-spacer>

          <v-btn icon v-if="isMobile">
            <v-icon @click="dialog = true">mdi-magnify</v-icon>
          </v-btn>
          <v-dialog v-model="dialog" :width="dialogWidth" class="mt-0">
            <v-card>
              <ais-instant-search
                :search-client="searchClient"
                index-name="academy_videos"
              >
                <ais-autocomplete placeholder="Search Videos">
                  <template v-slot="{ currentRefinement, indices, refine }">
                    <input
                      tabindex="-1"
                      autocomplete="off"
                      type="search"
                      id="autocomplete-search"
                      class="ais-SearchBox-input pl-8"
                      placeholder="Search for a video"
                      @input="refine($event.currentTarget.value)"
                    />
                    <ul
                      class="autocomplete-results"
                      v-if="currentRefinement"
                      v-for="index in indices"
                      :key="index.indexId"
                    >
                      <li
                        @click="openVideo(hit)"
                        class="mt-2"
                        v-for="hit in index.hits"
                        :key="hit.objectID"
                      >
                        <div class="mt-2">
                          <v-icon color="primary">mdi-play-box </v-icon>
                          <ais-highlight
                            class="pl-2"
                            attribute="title"
                            :hit="hit"
                          />
                        </div>
                      </li>
                    </ul>
                  </template>
                </ais-autocomplete>
              </ais-instant-search>

              <template v-slot:actions>
                <v-btn
                  class="ms-auto"
                  text="Ok"
                  @click="dialog = false"
                ></v-btn>
              </template>
            </v-card>
          </v-dialog>

          <v-btn v-if="route == 'home'" icon class="d-block d-md-none">
            <v-icon @click="toggleFilters()">mdi-filter</v-icon>
          </v-btn>

          <!-- <v-btn icon>
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn> -->
        </v-app-bar>
      </div>

      <v-main>
        <router-view></router-view>
      </v-main>

      <v-footer app> </v-footer>
    </v-app>
  </div>
</template>

<style>
#app {
  min-height: 100vh;
}

.autocomplete-results {
  list-style: none;
  padding: 12px;
}

.app-bar {
  background-color: black;
  z-index: 100;
}

.full-width-app-bar {
  background-color: black;
}

.v-dialog--active {
  position: absolute;
  top: 50px;
  /* Adjust this value to move the dialog upwards */
}

body,
h1 {
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
    Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
}

.ais-Highlight-highlighted {
  background: #0dd7b5 !important;
  font-style: normal;
}

@media (max-width: 900px) {
  .desktop-links {
    display: none;
  }
}

.v-item--active {
  background-color: #0dd7b5;
}

/* .v-btn--active {
  color: black !important;
} */

.custom-active-btn {
  color: black !important;
}

.v-app-bar-title__content {
  margin-top: 16px;
}

.v-app-bar-title__content:hover {
  cursor: pointer;
}

.v-navigation-drawer__content {
  background-color: white;
  filter: brightness(85%);
  height: 100%;
}

.sticky-list-item {
  position: sticky;
  top: 0;
  z-index: 100;
}

.header {
  display: flex;
  align-items: center;
  min-height: 50px;
  padding: 0.5rem 1rem;
  background: linear-gradient(to bottom, #0dd7b5, #01ac9b);
  color: #fff;
  margin-bottom: 1rem;
}

.header a {
  color: #fff;
  text-decoration: none;
}

.header-title {
  font-size: 1.2rem;
  font-weight: normal;
}

/* .header-title::after {
  content: ' ▸ ';
  padding: 0 0.5rem;
} */

.header-subtitle {
  font-size: 1.2rem;
}

.custom-active {
  background-color: #0dd7b5;
}

.search-panel {
  display: flex;
}

.search-panel__filters {
  flex: 1;
  margin-right: 1em;
}

.search-panel__results {
  flex: 3;
}

.searchbox {
  margin-bottom: 2rem;
}

.pagination {
  margin: 2rem auto;
  text-align: center;
}

.v-navigation-drawer {
  z-index: 100 !important;
}

.header-logo:hover {
  cursor: pointer;
}
</style>

<script>
import algoliasearch from 'algoliasearch';
import store from '@/store/index';

export default {
  filters: {
    firstLetter: function (title) {
      return title.charAt(0).toUpperCase();
    },
    truncate: function (title) {
      let maxLength = 46;
      if (title.length > maxLength) {
        return title.substring(0, maxLength) + '...';
      } else {
        return title;
      }
    },
  },
  data: () => ({
    searchClient: algoliasearch(
      process.env.VUE_APP_ALGOLIA_APP_ID,
      process.env.VUE_APP_ALGOLIA_KEY
    ),
    drawer: false,
    group: null,
    dialog: false,
    index: null,
  }),
  mounted() {
    this.index = this.searchClient.initIndex('academy_videos');
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },

    dialogWidth() {
      return this.$vuetify.breakpoint.xsOnly ? '100%' : '50%'; // Remove width prop for mobile, let Vuetify handle it
    },
    route() {
      return this.$route.name;
    },

    containerClass() {
      return this.isMobile ? '' : 'container';
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
  },
  methods: {
    getActiveColor(name) {
      return this.$route.name == name ? '#0DD7B5' : 'primary';
    },
    getActiveTextColor(name) {
      return this.$route.name == name
        ? 'mr-2 mt-2 elevation-0 custom-active-btn'
        : 'mr-2 mt-2 elevation-0 ';
    },
    toggleFilters() {
      this.$store.dispatch('search/TOGGLE_FILTERS_OPENED');
    },
    openVideo(video) {
      this.dialog = false;
      this.$router.push({ name: 'video', params: { id: video.objectID } });
    },
    navigateHome() {
      this.$router.push({ name: 'home' });
    },
    navigateToUserGuide() {
      window.open('https://docs.moasure.com', '_blank');
    },

    navigateToContactPage() {
      window.open('https://www.moasure.com/pages/contact-us');
    },
  },
};
</script>